import React, { Component } from 'react';
import { connect } from 'react-redux';
import {ONLINESTATUS} from '../../../../utils/questionManageType'

import axios from 'axios'
import API  from '../../../../API/api';
import { Button, Input,  Row, Col,message,Select,Modal,Popconfirm,Tooltip} from 'antd';
import {PropTypes} from 'prop-types';
import * as action from '../action'

const Option = Select.Option;
const ButtonGroup = Button.Group;
class DailyError extends Component {
    static contextTypes = {
        router: PropTypes.object.isRequired
    };
    state = {
    }

    shouldComponentUpdate(nextProps,nextState){
        if(nextProps.editionCurrent!==this.props.editionCurrent){
            this.getBookList(nextProps)
        }

        if(nextProps.handleBook){
        		this.props.setPropsBookCurrent(nextProps.handleBook)
        		this.props.setHandleBook('')
        }
        return true
    }


    //---------课本相关内容

    getBookList=(props=this.props)=>{
        let data = {
            edition_id:props.editionCurrent||(props.editionList[0]&&props.editionList[0].edition_id)//用nextprops的editionCurrent
        }
        this.props.getBookList(data,()=>{
        		if(props.handleBook){
        			this.props.setPropsBookCurrent(props.handleBook)
        			this.props.setHandleBook('')
        		}else if(this.props.bookList.length){
        			this.props.setPropsBookCurrent(this.props.bookList[0].book_id)
        		}else{
                this.props.setPropsBookCurrent('')
            }

        })

    }


    changeBook=(book)=>{//更换课本
        this.props.setPropsBookCurrent(book.book_id)
    }
    openEditBook = (val)=>{//打开课本修改
        this.setState({visibleBook:true,editBook:val,name:val.name,mark:val.mark,bookGrade:val.grade})
    }
    addEditBook = ()=>{//课本修改
        this.setState({visibleBook:true,editBook:{},name:'',mark:'',bookGrade:'1'})
    }
    editBook = ()=>{//课本修改
        if(this.state.name===''){
            return message.error('请填写名称')
        }
        let data ={
            name:this.state.name,
            mark:this.state.mark,
            grade:this.state.bookGrade
        }
        if(this.state.editBook.book_id){//编辑的情况
            data.book_id = this.state.editBook.book_id
            axios.post(API.FRAMEEWORK_BOOK_EDIT, data).then((res)=>{
                res = res.data
                if (res.code === 0) {
                    message.success(res.message)
                    this.props.bookList.forEach(d=>{
                        if(d.book_id===this.state.editBook.book_id){
                            d.name = this.state.name
                            d.mark = this.state.mark
                            d.grade = this.state.bookGrade
                        }
                    })//成功后直接直接给版本赋值
                    this.setState({visibleBook:false})
                }else{
                    message.error(res.message)
                }
            },()=>{message.error("网络错误！")})

        }else{
            //添加的情况
            data.edition_id = this.props.editionCurrent
            axios.post(API.FRAMEEWORK_BOOK_ADD, data).then((res)=>{
                res = res.data
                if (res.code === 0) {
                    message.success(res.message)
                    this.getBookList()
                    this.setState({visibleBook:false})

                }else{
                    message.error(res.message)
                }
            },()=>{message.error("网络错误！")})
        }

    }

    delBook = (id)=>{//删除版本
        let data ={
            book_id:id,
        }
        axios.post(API.FRAMEEWORK_BOOK_DEL, data).then((res)=>{
            res = res.data
            if (res.code === 0) {
                message.success(res.message)
                this.getBookList()
                this.props.setPropsBookCurrent((this.props.bookList[0]&&this.props.bookList[0].book_id)||'-1')

            }else{
                message.error(res.message)
            }
        },()=>{message.error("网络错误！")})
    }
    onlineBook= (id)=>{//版本上线
        let data ={
            book_id:id,
        }
        axios.post(API.FRAMEEWORK_BOOK_ONLINE, data).then((res)=>{
            res = res.data
            if (res.code === 0) {
                message.success('成功 次日生效')
                this.getBookList()
            }else{
                message.error(res.message)
            }
        },()=>{message.error("网络错误！")})
    }
    offlineBook= (id)=>{//课本下线
        let data ={
            book_id:id,
        }
        axios.post(API.FRAMEEWORK_BOOK_OFFLINE, data).then((res)=>{
            res = res.data
            if (res.code === 0) {
                // message.success(res.message)
                message.success('成功 次日生效')
                this.getBookList()
            }else{
                message.error(res.message)
            }
        },()=>{message.error("网络错误！")})
    }
    onBookDragStart= (e,val,i)=>{//课本移动
        this.setState({dragBookIndex:i})
    }
    onBookDragEnd= (e,val,i)=>{//课本移动
        //
    }
    moveBook= (e,i)=>{//课本移动

        let list = this.props.bookList
        let book = list.splice(this.state.dragBookIndex,1)[0]
        list.splice(i,0,book)
        this.setState({dragBookIndex:i})
        this.props.setPropsBookList(list)
    }
    moveBookDrop=(e)=>{
        let data = {
            book_id:this.props.bookList[this.state.dragBookIndex].book_id,
            order_num:this.state.dragBookIndex,
        }
        axios.post(API.FRAMEEWORK_BOOK_MOVE, data).then((res)=>{
            res = res.data
            if (res.code === 0) {
                // message.success(res.message)
            }else{
                message.error(res.message)
                this.getBookList()
            }
        },()=>{message.error("网络错误！")})
    }



    render() {
        const gradeMap = {1:'一年级',2:'二年级',3:'三年级',4:'四年级',5:'五年级',6:'六年级',};
        return (
            <div>

                        <Row style={{marginBottom: 20}}>
                            <Col span={2} className="popup-input-title" style={{lineHeight:'28px',textAlign:'center',paddingRight:'5px',fontSize:'15px',fontWeight:'500'}}><label>课本：</label></Col>
                            <Col span={22} style={{paddingLeft:10,textAlign:'left'}}>
                                {
                                    this.props.bookList&&this.props.bookList.map((val, key) =>

                                            <ButtonGroup style={{marginRight:20,marginBottom:10}} key={val.book_id}
                                                         size={'small'}
                                                         draggable={!!(this.props.user.role_assist&&this.props.user.role_assist.moveBook)}
                                                         onDragStart={(e)=>{this.onBookDragStart(e,val,key)}}
                                                         onDragEnter={(e)=>{this.moveBook(e,key)}}
                                                         onDragEnd={(e)=>{this.moveBookDrop(e,key)}}>
                                                <Tooltip title={val.book_id}>
                                                    <Button type={this.props.bookCurrent===val.book_id?'primary':''} style={{borderColor:'2'===''+val.online_status?'rgb(90, 155, 254)':'d9d9d9'}}
                                                        onClick={()=>{this.changeBook(val)}}
                                                        value={val.book_id} >{val.name}({gradeMap[val.grade]})--{ONLINESTATUS[val.online_status]}</Button>
                                                </Tooltip>
                                                {
                                                    this.props.user.role_assist&&this.props.user.role_assist.editBook&&
                                                    <Tooltip title={'编辑课本'} mouseEnterDelay={1}>
                                                        <Button  type={this.props.bookCurrent===val.book_id?'primary':''} style={{borderColor:'2'===''+val.online_status?'rgb(90, 155, 254)':'d9d9d9'}}
                                                                                        onClick={()=>{this.openEditBook(val)}}
                                                                                        icon="edit" />
                                                    </Tooltip>

                                                }
                                                {
                                                    this.props.user.role_assist&&this.props.user.role_assist.delBook&&
                                                    <Popconfirm title="确认删除吗？" onConfirm={(e) => {this.delBook(val.book_id)}} okText="确认" cancelText="取消">

                                                        <Tooltip title={'删除课本'} mouseEnterDelay={1}>
                                                            <Button  type={this.props.bookCurrent===val.book_id?'primary':''} icon="delete"  style={{borderColor:'2'===''+val.online_status?'rgb(90, 155, 254)':'d9d9d9'}}/>
                                                        </Tooltip>
                                                    </Popconfirm>
                                                }
                                                {
                                                    this.props.user.role_assist&&this.props.user.role_assist.online&&
                                                    <Popconfirm title="确认上线吗？" onConfirm={(e) => {this.onlineBook(val.book_id)}} okText="确认" cancelText="取消">

                                                        <Tooltip title={'上线课本'} mouseEnterDelay={1}>
                                                           <Button  type={this.props.bookCurrent===val.book_id?'primary':''} icon="to-top"  style={{borderColor:'2'===''+val.online_status?'rgb(90, 155, 254)':'d9d9d9'}}/>
                                                        </Tooltip>
                                                    </Popconfirm>
                                                }
                                                {
                                                    this.props.user.role_assist&&this.props.user.role_assist.offline&&
                                                    <Popconfirm title="确认下线吗？" onConfirm={(e) => {this.offlineBook(val.book_id)}} okText="确认" cancelText="取消">

                                                        <Tooltip title={'下线课本'} mouseEnterDelay={1}>
                                                            <Button  type={this.props.bookCurrent===val.book_id?'primary':''} icon="arrow-down"  style={{borderColor:'2'===''+val.online_status?'rgb(90, 155, 254)':'d9d9d9'}}/>
                                                        </Tooltip>
                                                    </Popconfirm>
                                                }

                                            </ButtonGroup>

                                    )

                                }
                                {
                                    this.props.user.role_assist&&this.props.user.role_assist.addBook&&
                                    <ButtonGroup style={{marginRight:20,marginBottom:10,fontWeight:'600'}} >
                                        <Tooltip title={'添加课本'} mouseEnterDelay={1}>
                                            <Button  type={'primary'}
                                                    size={'small'}
                                                    onClick={()=>{this.addEditBook()}}
                                                    icon="plus" />
                                        </Tooltip>

                                    </ButtonGroup>
                                }
                            </Col>
                        </Row>



                {/*课本 修改 增加的模态框*/}
                <Modal
                    title={'课本管理'}
                    visible={ this.state.visibleBook }
                    onOk={ this.editBook }
                    onCancel={ ()=>{this.setState({visibleBook:false})} }
                    okText = { '确定' }
                >
                    <Row className="row">
                        <Col span={2}>名称：</Col>
                        <Col span={22}>
                            <Input placeholder = "输入名称(必填)" value={this.state.name} onChange = { e => this.setState({name:e.target.value}) } />
                        </Col>
                    </Row>
                    <Row className="row" style={{marginTop:20}} >
                        <Col span={2}>年级：</Col>
                        <Col span={22}>
                            <Select value={''+this.state.bookGrade} style={{width: 120}} onSelect={ (val)=>{this.setState({bookGrade:val})} }>
                                {
                                    this.props.filterList.map(d=>
                                        <Option key={''+d.id} value={''+d.id}>{d.name}</Option>
                                    )
                                }
                            </Select>
                        </Col>
                    </Row>
                    <Row className="row"  style={{marginTop:20}}>
                        <Col span={2}>概要</Col>
                        <Col span={22}>
                            <Input placeholder = "输入概要(非必填)" value={this.state.mark} onChange = {  e => this.setState({mark:e.target.value}) } />
                        </Col>
                    </Row>
                </Modal>

            </div>
        )
    }
}

function mapState(state) {
    const asstst = state.knowledgeAssist.assist;
    return {
        user:state.user,
        editionCurrent:asstst.editionCurrent,
        editionList:asstst.editionList,
        bookCurrent:asstst.bookCurrent,
        bookList:asstst.bookList,
        filterList:asstst.filterList,
        handleBook:asstst.handleBook,
    };
}

function mapDispatch(dispatch) {
    return{
        setPropsBookCurrent:(val)=>{
            dispatch(action.setPropsBookCurrent(val))
        },
        getBookList:(val,cb)=>{
            dispatch(action.getBookList(val,cb))
        },
        setHandleEdition:(val)=>{
            dispatch(action.setHandleEdition(val))
        },
        setHandleBook:(val)=>{
            dispatch(action.setHandleBook(val))
        },
        setPropsBookList:(val)=>{
            dispatch(action.setPropsBookList(val))
        },
    }
}
export default connect(mapState, mapDispatch)(DailyError);


// WEBPACK FOOTER //
// ./src/entry_app/knowledge_assist/assist/Books/view.js